<template>
  <div class="page">
    <div class="my-spinner">
      <comp-icon
      v-bind:icon="'spinnerPuff'"
      v-bind:width="60"></comp-icon>
    </div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'loading',
  components: {
    CompIcon
  }
}
</script>

<style scoped>
.page {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.my-spinner {
  /* common */
  color: #fefefe;
}

</style>



// WEBPACK FOOTER //
// src/pages/Loading.vue